import {Injectable} from '@angular/core';
import {Router, ActivationEnd} from '@angular/router';
import {filter} from 'rxjs/operators';
import * as Sentry from '@sentry/angular';

/**
 * Tracks Angular route activations and logs them as Sentry breadcrumbs.
 * Each breadcrumb includes the route path and the rendered component name,
 * so the Sentry event trail shows exactly which page/component was active.
 */
@Injectable({providedIn: 'root'})
export class SentryRouteTrackerService {
  constructor(private router: Router) {
    this.router.events.pipe(
      filter((event): event is ActivationEnd => event instanceof ActivationEnd),
    ).subscribe(event => {
      const snapshot = event.snapshot;
      const component = snapshot.component;
      if (!component) return;

      const componentName = typeof component === 'string' ? component : component.name;
      const routePath = snapshot.routeConfig?.path || '/';

      // Set as a Sentry tag so it appears directly on the error event
      Sentry.setTag('angular.component', componentName);

      Sentry.addBreadcrumb({
        category: 'route',
        message: `${routePath} → ${componentName}`,
        level: 'info',
        data: {
          route: routePath,
          component: componentName,
          params: snapshot.params,
        },
      });
    });
  }
}
